import React, { memo } from 'react'
import { Box, Card, Stack } from '@mui/material'

import { ACCOUNT_PROFILE_DISPATCH } from '../../store/reducers/account/account'
import SubmitButton from '../shared/button/SubmitButton'
import CardHeading from '../shared/text/CardHeading'
import CustomTextField from '../shared/inputs/CustomTextField'
import CustomForm from '../shared/inputs/CustomForm'

const ChangePersonalInfo = ({
  onFormSubmit,
  dispatchAction,
  accountProfile: { error, success, firstNameTemp, lastNameTemp, isProcessing },
  t,
  isPresent,
  isKycSuccess
}) => {
  return (
    <Card
      sx={{
        p: 3
      }}
    >
      <CustomForm onFormSubmit={onFormSubmit}>
        <CardHeading title={t('user-account.personal-info')} />
        <Box
          sx={{
            rowGap: 3,
            columnGap: 2,
            display: 'grid',
            gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' }
          }}
        >
          <CustomTextField
            label={t('common.first-name')}
            error={t(error[ACCOUNT_PROFILE_DISPATCH.FIRST_NAME_TEMP])}
            success={t(success[ACCOUNT_PROFILE_DISPATCH.FIRST_NAME_TEMP])}
            value={firstNameTemp}
            onChange={(value) =>
              dispatchAction(ACCOUNT_PROFILE_DISPATCH.FIRST_NAME_TEMP, value)
            }
            disabled={isKycSuccess}
          />
          <CustomTextField
            label={t('common.last-name')}
            error={t(error[ACCOUNT_PROFILE_DISPATCH.LAST_NAME_TEMP])}
            success={t(success[ACCOUNT_PROFILE_DISPATCH.LAST_NAME_TEMP])}
            value={lastNameTemp}
            onChange={(value) =>
              dispatchAction(ACCOUNT_PROFILE_DISPATCH.LAST_NAME_TEMP, value)
            }
            disabled={isKycSuccess}
          />
        </Box>
        {!isKycSuccess && (
          <Stack spacing={3} sx={{ mt: 3, alignItems: 'flex-end' }}>
            <SubmitButton
              size='default'
              label={t('common.save')}
              loading={isPresent && isProcessing}
            />
          </Stack>
        )}
      </CustomForm>
    </Card>
  )
}

export default memo(ChangePersonalInfo)
